// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2Rxaq","label":"SetPasswdForm_label__2iJpH"};